/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * カートレコメンド（ミニカート）: ワンクリック追加
 * ミニカートは <form> なので、商品フォームを入れ子にすると壊れる。
 * そのためフォームを使わず、ボタンの data-variant-id を直接 /cart/add.js に投げ、
 * テーマ標準の "product:added" イベントを発火してミニカート再描画＆展開に乗せる。
 * イベント委譲なので、ミニカート再描画後のボタンにも効く。
 */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-cart-recommend-add');
    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.hasAttribute('disabled')) {
      return;
    }

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      return;
    }

    var addUrl = (window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl : '/cart/add';

    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        button.removeAttribute('disabled');

        // テーマ標準のイベントを発火（ヘッダーが拾って再描画＆ドロワー展開）
        button.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            button: button,
            variant: null,
            quantity: 1,
            productAdded: response.ok
          }
        }));

        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        }
      })
      .catch(function () {
        button.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  });
})();

/**
 * FBT バンドル（よく一緒に購入されています）
 * - チェックボックスの増減で合計金額とボタンの点数をリアルタイム更新
 * - 「まとめてカートに入れる」で選択中の variant を一括 /cart/add.js
 *   → product:added を発火してミニカート再描画＆展開
 * JPYは整数（例: 2980 = ¥2,980）前提で集計。
 */
(function () {
  // Shopify の金額は「セント（×100）」の整数。JPY表示は100で割って小数なしにする。
  function formatYen(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  // 行の価格表示を更新（セール時はセール価格＋取り消し線）
  function setRowPrice(rowPrice, price, compare) {
    if (!rowPrice) return;
    if (compare > price) {
      rowPrice.innerHTML =
        '<span class="fbt-bundle__price-sale">' + formatYen(price) + '</span> ' +
        '<s class="fbt-bundle__price-compare">' + formatYen(compare) + '</s>';
    } else {
      rowPrice.textContent = formatYen(price);
    }
  }

  function recalc(bundle) {
    var checks = bundle.querySelectorAll('.fbt-bundle__check');
    var total = 0;
    var savings = 0;
    var count = 0;
    checks.forEach(function (c) {
      if (c.checked) {
        var price = parseInt(c.getAttribute('data-price') || '0', 10);
        var compare = parseInt(c.getAttribute('data-compare') || '0', 10);
        total += price;
        if (compare > price) savings += (compare - price);
        count += 1;
      }
    });
    var totalEl = bundle.querySelector('[data-fbt-total]');
    if (totalEl) totalEl.textContent = formatYen(total);
    var savingsEl = bundle.querySelector('[data-fbt-savings]');
    if (savingsEl) {
      if (savings > 0) {
        savingsEl.textContent = formatYen(savings) + 'お得';
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
    var countEl = bundle.querySelector('[data-fbt-btn-count]');
    if (countEl) countEl.textContent = count;
    var btn = bundle.querySelector('.js-fbt-add');
    if (btn) btn.disabled = count === 0;
  }

  document.addEventListener('change', function (event) {
    // variant セレクトの変更 → そのチェックボックスの variant/価格を更新
    var select = event.target.closest('.fbt-bundle__variant');
    if (select) {
      var row = select.closest('[data-fbt-item]');
      if (!row) return;
      var opt = select.options[select.selectedIndex];
      var price = opt ? (opt.getAttribute('data-price') || '0') : '0';
      var variantId = opt ? opt.value : '';
      var compare = opt ? (opt.getAttribute('data-compare') || '0') : '0';
      var check = row.querySelector('.fbt-bundle__check');
      if (check) {
        check.setAttribute('data-variant-id', variantId);
        check.setAttribute('data-price', price);
        check.setAttribute('data-compare', compare);
      }
      setRowPrice(row.querySelector('[data-fbt-row-price]'), parseInt(price, 10), parseInt(compare, 10));
      var bundleSel = select.closest('.fbt-bundle');
      if (bundleSel) recalc(bundleSel);
      return;
    }

    // チェックボックスの切り替え
    var checkbox = event.target.closest('.fbt-bundle__check');
    if (!checkbox) return;
    var bundle = checkbox.closest('.fbt-bundle');
    if (bundle) recalc(bundle);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-fbt-add');
    if (!btn) return;
    event.preventDefault();
    if (btn.hasAttribute('disabled')) return;

    var bundle = btn.closest('.fbt-bundle');
    if (!bundle) return;

    var items = [];
    var addedBoxes = [];
    bundle.querySelectorAll('.fbt-bundle__check').forEach(function (c) {
      if (c.checked) {
        items.push({ id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 });
        addedBoxes.push(c);
      }
    });
    if (items.length === 0) return;

    var addUrl = (window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl : '/cart/add';

    btn.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        btn.removeAttribute('disabled');
        if (response.ok) {
          // 追加した行を「カートに入っています」に切り替え、チェックを外す
          addedBoxes.forEach(function (c) {
            c.checked = false;
            var row = c.closest('[data-fbt-item]');
            if (row) row.classList.add('fbt-bundle__row--in-cart');
          });
          recalc(bundle);
        }
        btn.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            button: btn,
            variant: null,
            quantity: items.length,
            productAdded: response.ok
          }
        }));
        if (!response.ok) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        }
      })
      .catch(function () {
        btn.removeAttribute('disabled');
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  });

  // 対象商品（この商品）の variant を、上部の購入ボックスの選択に連動させる
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    document.querySelectorAll('.fbt-bundle').forEach(function (bundle) {
      var row = bundle.querySelector('[data-fbt-current]');
      if (!row) return;
      var price = parseInt(variant.price, 10) || 0;
      var compare = parseInt(variant.compare_at_price, 10) || 0;
      var check = row.querySelector('.fbt-bundle__check');
      if (check) {
        check.setAttribute('data-variant-id', variant.id);
        check.setAttribute('data-price', price);
        check.setAttribute('data-compare', compare);
      }
      // バンドル側の対象商品ドロップダウンも上の選択に合わせる
      var sel = row.querySelector('.fbt-bundle__variant');
      if (sel && sel.querySelector('option[value="' + variant.id + '"]')) {
        sel.value = String(variant.id);
      }
      setRowPrice(row.querySelector('[data-fbt-row-price]'), price, compare);
      recalc(bundle);
    });
  });
})();

